/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";
import { styled } from "../../stitches.config";

const Container = styled("div", {
  "& h2": {
    marginTop: "50px",
    textAlign: "center",
  },
  "& hr": {
    height: "1px",
    color: "#666",
    backgroundColor: "#666",
    border: "none",
    marginTop: "50px",
  },
});

const SliderGrid = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
});

const Slide = styled("div", {
  height: "240px",
  width: "180px",
  marginBottom: "20px",
  "& img": {
    height: "240px",
    width: "180px",
  },
});

const PricingTable = styled("div", {
  display: "block",
  margin: "auto",
  width: "600px",
  maxWidth: "100%",

  "& table": {
    width: "100%",
    margin: "auto",
  },
  "& th": {
    backgroundColor: "$primary",
    color: "black",
    width: "33%",
  },
  "& td": {
    color: "white",
    textAlign: "center",
  },
  "& td:nth-child(2)": {
    color: "$text",
    textDecoration: "line-through",
  },
});

const ShopButton = styled("a", {
  marginTop: "20px",
  display: "block",
  backgroundColor: "#fca903",
  color: "white",
  padding: "0.75rem",
  fontSize: "1.5rem",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  textAlign: "center",
  fontWeight: "bold",
  fontVariant: "small-caps",
  textDecoration: "none",
});

export const Commissions = () => {
  return (
    <Layout>
      <Container>
        {/* 
                <h1>Commissions</h1>
                <h2>Holiday Portriat Sale 2024</h2>
                <SliderGrid>
                    <Slide>
                        <img
                            alt="Kilton"
                            src="/images/commissions/kilton.png"
                        />
                    </Slide>
                    <Slide>
                        <img alt="Laney" src="/images/commissions/laney.jpg" />
                    </Slide>
                    <Slide>
                        <img alt="Kitty" src="/images/commissions/kitty.png" />
                    </Slide>
                    <Slide>
                        <img
                            alt="Alan Wallace Portrait"
                            src="/images/commissions/alan-wallace.jpg"
                        />
                    </Slide>
                    <Slide>
                        <img
                            alt="Rocket Portrait"
                            src="/images/commissions/rocket.png"
                        />
                    </Slide>
                    <Slide>
                        <img
                            alt="Curly Fries Portrait"
                            src="/images/commissions/curly-fries.jpg"
                        />
                    </Slide>
                </SliderGrid>
                <p>
                    Celebrate the holidays with a timeless portrait of your
                    loved ones—furry or human. Whether you're looking for a
                    striking statement piece or a more intimate keepsake, I
                    offer portraits in a range of sizes to suit any space. Each
                    piece is painted by hand in oils on wood panel and crafted
                    with care, capturing the essence of personality and
                    connection. With fixed pricing, the process is simple and
                    transparent, so you can focus on choosing the perfect size
                    for your home. Let’s create something truly memorable this
                    holiday season.
                </p>
                <p>
                    Creating your custom portrait is simple and personal. Book
                    your spot, provide reference photos, and choose the size for
                    your piece. The first two clients to book before December
                    10th are guaranteed delivery by December 24th; all others
                    will be completed within 90 days of payment. This
                    Thanksgiving sale runs through New Year’s Eve 2024. Single
                    subject portraits only.
                </p>
                <PricingTable>
                    <h4>Portrait pricing</h4>
                    <table>
                        <tbody>
                        <tr>
                            <th>Size</th>
                            <th>Normal price</th>
                            <th>Thanksgiving Sale</th>
                        </tr>
                        <tr>
                            <td>18x24</td>
                            <td>$2000</td>
                            <td>$1350</td>
                        </tr>
                        <tr>
                            <td>16x20</td>
                            <td>$1500</td>
                            <td>$1000</td>
                        </tr>
                        <tr>
                            <td>12x16</td>
                            <td>$1000</td>
                            <td>$650</td>
                        </tr>
                        <tr>
                            <td>12x12</td>
                            <td>$750</td>
                            <td>$500</td>
                        </tr>
                        </tbody>
                    </table>

                    <ShopButton href="https://shop.seekingsomaart.com/product/holiday-sale-portraits">
                        Shop now!
                    </ShopButton>
                </PricingTable>
                <hr></hr> */}
        <h2>Commissions</h2>
        <p>
          I am open to select commissions for fine art, design, and illustration
          projects, depending on the nature of the work. I prioritize projects
          that align with my artistic vision and inspire me to bring them to
          life.
        </p>
        <p>
          If you’re interested in commissioning a piece or discussing a project,
          I’d love to hear from you.
          <Link to="/contact">Click here to fill out the contact form</Link> and
          let’s start creating something meaningful together.
        </p>
      </Container>
    </Layout>
  );
};

export default Commissions;
